module.exports = __webpack_public_path__ + "static/media/3.2 Bellevois Detail OfR klein.60c5897f.jpg";